import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _simpleActions;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { PUT_ERROR_MESSAGE, RESET_CHAT, SET_BUTTON_NOTIFICATION, SET_CHAT_ID, SET_CHAT_URL, SET_CUSTOMER_ID, SET_GROUPS_TOKEN, SET_LOGIN, SET_POLLING_KEY, SET_SETTINGS, SET_SOUND_NOTIFICATION, SET_STEP, SET_TOKEN, SET_TOPICS, UPDATE_MESSAGES } from "../actions/chatWithOperator";
import { SET_FEEDBACK_MODEL } from "../../components/Header2021/actions/actionTypes";
import { formatFileSize } from "../../utils/format-string";
import guid from "../../utils/guid-generator";
var getNewState = function getNewState(oldState, newData) {
  return _objectSpread(_objectSpread({}, oldState), {
    chatWithOperator: _objectSpread(_objectSpread({}, oldState.chatWithOperator), newData)
  });
};
var codes = {
  10: 'operator',
  11: 'user',
  12: 'typing'
};
var simpleActions = (_simpleActions = {}, _defineProperty(_simpleActions, SET_CHAT_ID, 'chatId'), _defineProperty(_simpleActions, SET_CUSTOMER_ID, 'customerId'), _defineProperty(_simpleActions, SET_STEP, 'step'), _defineProperty(_simpleActions, SET_LOGIN, 'login'), _defineProperty(_simpleActions, SET_TOKEN, 'token'), _defineProperty(_simpleActions, SET_POLLING_KEY, 'pollingKey'), _defineProperty(_simpleActions, SET_GROUPS_TOKEN, 'groupsToken'), _defineProperty(_simpleActions, SET_SOUND_NOTIFICATION, 'isSoundNotified'), _defineProperty(_simpleActions, SET_BUTTON_NOTIFICATION, 'isSoundNotified'), _defineProperty(_simpleActions, SET_CHAT_URL, 'chatUrl'), _defineProperty(_simpleActions, SET_TOPICS, 'topics'), _defineProperty(_simpleActions, SET_FEEDBACK_MODEL, 'chatParams'), _simpleActions);
function getText(text, chatUrl) {
  text = text.replace(/<\/?[^>]+(>|$)/g, '');
  try {
    if (text.indexOf('\\file\\') !== -1) {
      var data = JSON.parse(text.replace('\\file\\ ', '').replace(' \\/file\\', ''));
      // eslint-disable-next-line max-len
      return "<a class=\"downloadFile\" href=\"".concat(chatUrl, "api/file/").concat(data.id, "\" target=\"_blank\" rel='nofollow noopener'>").concat(data.name, "</a>,\n").concat(formatFileSize(data.size));
    }
    if (text.indexOf('\\link\\') !== -1) {
      return text.split('\\link\\').map(function (el) {
        return el.split('\\/link\\');
      }).reduce(function (acc, curr) {
        return acc.concat(curr.reduce(function (subAcc, subEl) {
          return subAcc.concat(subEl);
        }, []));
      }, []).map(function (textPart) {
        if (textPart.indexOf('url') === -1) return textPart;
        var data = JSON.parse(textPart);
        return "<a href=\"".concat(data.url, "\" target=\"_blank\" rel='nofollow noopener' >").concat(data.caption, "</a>");
      }).join(' ').replace(/\n/g, '<br />\n');
    }
    if (text.indexOf("\\upload\\") !== -1) {
      return '<a href="#">Приложить файл</a>';
    }
    if (text.indexOf('\r\n\r\n') !== -1) {
      return text.split('\r\n\r\n').join('<br/><br/>');
    }
    return text;
  } catch (ex) {
    return text;
  }
}
export function chatWithOperator() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    type = _ref.type,
    payload = _ref.payload;
  if (simpleActions[type]) {
    return getNewState(state, _defineProperty({}, simpleActions[type], payload));
  }
  if (type === SET_SETTINGS) {
    return getNewState(state, {
      languages: payload.Languages,
      config: payload.Configuration
    });
  }
  if (type === PUT_ERROR_MESSAGE) {
    var messagesOrder = (state.chatWithOperator.messagesOrder || []).slice();
    var messages = state.chatWithOperator.messages || {};
    var id = guid();
    messages[id] = {
      text: payload,
      type: 'system'
    };
    messagesOrder.push(id);
    return getNewState(state, {
      messages: messages,
      messagesOrder: messagesOrder
    });
  }
  if (type === UPDATE_MESSAGES) {
    var chat = state.chatWithOperator;
    var chatUrl = chat.chatUrl;
    var _messages = chat.messages || {};
    var _messagesOrder = (payload.init ? [] : chat.messagesOrder || []).slice();
    // todo: расхардкодить, вынести в qp этот параметр
    var botEndMessage = chat.chatParams.botEndMessage || 'Ваше обращение переводится к оператору';
    var operatorTyping = null;
    var isSoundNotified = true;
    var isBot = typeof chat.isBotMessage === 'boolean' ? chat.isBotMessage : !!botEndMessage;
    payload.messages.forEach(function (message) {
      message.Id = message.Id || guid();
      if (codes[message.Code] === 'typing') {
        operatorTyping = message.Content;
        return;
      }
      if (codes[message.Code] !== 'user') {
        isSoundNotified = false;
      }
      if (isBot && botEndMessage) {
        isBot = message.Content.indexOf(botEndMessage) === -1;
      }
      _messages[message.Id] = {
        nickname: isBot && codes[message.Code] !== 'user' ? 'Электронный помощник' : message.UserName,
        time: message.Timestamp,
        text: getText(message.Content, chatUrl),
        type: codes[message.Code] || 'system',
        isBot: isBot
      };
      if (_messagesOrder.indexOf(message.Id) === -1) {
        _messagesOrder.push(message.Id);
      }
    });
    return getNewState(state, {
      messages: _messages,
      messagesOrder: _messagesOrder,
      operatorTyping: operatorTyping,
      isSoundNotified: isSoundNotified,
      isBotMessage: isBot
    });
  }
  if (type === RESET_CHAT) {
    return getNewState(state, {
      messages: {},
      messagesOrder: [],
      operatorTyping: false,
      isSoundNotified: true,
      chatId: null,
      customerId: null,
      token: null,
      pollingKey: null,
      groupsToken: null
    });
  }
  return state;
}